import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { XCircle } from 'lucide-react';

export default function PaymentCancel() {
  const navigate = useNavigate();

  return (
    <div className="pt-24 pb-16 min-h-screen flex items-center justify-center" data-testid="payment-cancel-page">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        className="max-w-md w-full mx-6 text-center"
      >
        <div className="bg-zinc-900/50 border border-yellow-500/30 rounded-2xl p-12">
          <div className="w-20 h-20 rounded-full bg-yellow-500/20 flex items-center justify-center mx-auto mb-6">
            <XCircle className="w-10 h-10 text-yellow-400" />
          </div>
          <h1 className="text-2xl font-bold text-white mb-2">Payment Cancelled</h1>
          <p className="text-zinc-400 mb-8">
            Your payment was cancelled. No charges were made. 
            You can try again or browse other agents.
          </p>
          <div className="flex flex-col gap-3">
            <Button
              onClick={() => navigate('/agents')}
              className="bg-cyan-500 hover:bg-cyan-600 text-white rounded-none"
              data-testid="browse-agents-btn"
            >
              Browse Agents
            </Button>
            <Button
              variant="outline"
              onClick={() => navigate('/dashboard')}
              className="border-white/20 text-zinc-300"
            >
              Go to Dashboard
            </Button>
          </div>
        </div>
      </motion.div>
    </div>
  );
}
